/** ISO-3166 alpha-2 codes a seasonal theme can target; extend when a theme needs a new region. */
export const COUNTRY_CODES = ["BR", "PT", "US", "AR", "UY", "PY", "CL", "MX", "ES"] as const

/** A supported ISO-3166 alpha-2 country code. */
export type CountryCode = (typeof COUNTRY_CODES)[number]

const ALIASES: Readonly<Record<string, CountryCode>> = {
  BRA: "BR",
  BRASIL: "BR",
  BRAZIL: "BR",
  PRT: "PT",
  PORTUGAL: "PT",
  USA: "US",
  "UNITED STATES": "US",
  "ESTADOS UNIDOS": "US",
  ARG: "AR",
  ARGENTINA: "AR",
  URY: "UY",
  URUGUAY: "UY",
  URUGUAI: "UY",
  PRY: "PY",
  PARAGUAY: "PY",
  PARAGUAI: "PY",
  CHL: "CL",
  CHILE: "CL",
  MEX: "MX",
  MEXICO: "MX",
  "MÉXICO": "MX",
  ESP: "ES",
  SPAIN: "ES",
  ESPANHA: "ES",
  "ESPAÑA": "ES",
}

function isCountryCode(value: string): value is CountryCode {
  return (COUNTRY_CODES as readonly string[]).includes(value)
}

/** Maps a free-form merchant country (code, alpha-3 or name, any case) to its alpha-2 code. */
export function normalizeCountry(raw?: string | null): CountryCode | null {
  const key = raw?.trim().toUpperCase()
  if (!key) return null
  if (isCountryCode(key)) return key
  return ALIASES[key] ?? null
}
